module.exports = __webpack_public_path__ + "img/portrait_icon.05f597b9.png";